import axiosInstance from './axiosInstance';

const ROLES_BASE_URL = '/Corrohealth/api/roles';

// Role CRUD Operations
export const getAllRoles = async () => {
  const response = await axiosInstance.get(ROLES_BASE_URL);
  return response.data.data || [];
};

// Get active role names for dropdown
export const getActiveRoleNames = async () => {
  const roles = await getAllRoles();
  return roles
    .filter(role => role.active)
    .map(role => role.roleName);
};

export const getRoleById = async (roleId) => {
  const response = await axiosInstance.get(`${ROLES_BASE_URL}/${roleId}`);
  return response.data.data;
};

export const createRole = async (roleData) => {
  const response = await axiosInstance.post(ROLES_BASE_URL, roleData);
  return response.data.data;
};

export const updateRole = async (roleId, roleData) => {
  const response = await axiosInstance.put(`${ROLES_BASE_URL}/${roleId}`, roleData);
  return response.data.data;
};

export const deleteRole = async (roleId) => {
  const response = await axiosInstance.delete(`${ROLES_BASE_URL}/${roleId}`);
  return response.data;
};

// Permission Management
export const getRolePermissions = async (roleId) => {
  const response = await axiosInstance.get(`${ROLES_BASE_URL}/${roleId}/permissions`);
  return response.data.permissions || [];
};

export const updateRolePermissions = async (roleId, permissions) => {
  const response = await axiosInstance.put(`${ROLES_BASE_URL}/${roleId}/permissions`, { permissions });
  return response.data;
};

export const assignPermission = async (roleId, permissionData) => {
  const response = await axiosInstance.post(`${ROLES_BASE_URL}/${roleId}/permissions`, permissionData);
  return response.data;
};

export const removePermission = async (roleId, permissionId) => {
  const response = await axiosInstance.delete(`${ROLES_BASE_URL}/${roleId}/permissions/${permissionId}`);
  return response.data;
};

// Module and Permission Level Metadata
export const getAvailableModules = async () => {
  const response = await axiosInstance.get(`${ROLES_BASE_URL}/modules`);
  return response.data.data || [];
};

export const getPermissionLevels = async () => {
  const response = await axiosInstance.get(`${ROLES_BASE_URL}/permission-levels`);
  return response.data.data || [];
};

// Location Assignment
export const assignLocations = async (roleId, locations) => {
  const response = await axiosInstance.post(`${ROLES_BASE_URL}/${roleId}/locations`, { locations });
  return response.data;
};

export const removeLocation = async (roleId, location) => {
  const response = await axiosInstance.delete(`${ROLES_BASE_URL}/${roleId}/locations/${location}`);
  return response.data;
};

// Role Status Management
export const activateRole = async (roleId) => {
  const response = await axiosInstance.post(`${ROLES_BASE_URL}/${roleId}/activate`);
  return response.data;
};

export const deactivateRole = async (roleId) => {
  const response = await axiosInstance.post(`${ROLES_BASE_URL}/${roleId}/deactivate`);
  return response.data;
};

// User Assignment
export const getRoleUsers = async (roleId) => {
  const response = await axiosInstance.get(`${ROLES_BASE_URL}/${roleId}/users`);
  return response.data.data?.users || [];
};

export const assignUserToRole = async (roleId, userId) => {
  const response = await axiosInstance.post(`${ROLES_BASE_URL}/${roleId}/users/${userId}`);
  return response.data;
};

export const removeUserFromRole = async (roleId, userId) => {
  const response = await axiosInstance.delete(`${ROLES_BASE_URL}/${roleId}/users/${userId}`);
  return response.data;
};

// Bulk Operations
export const bulkAssignPermissions = async (roleId, permissions) => {
  const response = await axiosInstance.post(`${ROLES_BASE_URL}/${roleId}/permissions/bulk`, { permissions });
  return response.data;
};

export const cloneRole = async (roleId, newRoleName) => {
  const response = await axiosInstance.post(`${ROLES_BASE_URL}/${roleId}/clone`, { newRoleName });
  return response.data.data;
};

// Beta Allowlist (Module Overrides)
const MODULE_OVERRIDES_URL = '/Corrohealth/api/module-overrides';

export const getBetaUsers = async (roleId, module) => {
  const response = await axiosInstance.get(MODULE_OVERRIDES_URL, { params: { roleId, module } });
  return response.data.data || [];
};

export const addBetaUser = async (roleId, module, userId, accessLevel = 'READ') => {
  const response = await axiosInstance.post(MODULE_OVERRIDES_URL, { roleId, module, userId, accessLevel });
  return response.data;
};

export const removeBetaUser = async (overrideId) => {
  const response = await axiosInstance.delete(`${MODULE_OVERRIDES_URL}/${overrideId}`);
  return response.data;
};

export const searchBetaUsers = async (query, roleId) => {
  const params = { query };
  if (roleId) params.roleId = roleId;
  const response = await axiosInstance.get(`${MODULE_OVERRIDES_URL}/search-users`, { params });
  return response.data.data || [];
};
